
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import Header from "@/components/header/Comheader.vue";
import { useRoute, onBeforeRouteUpdate } from "vue-router";
import axios from "axios";

export default defineComponent({
  components: {
    Header,
  },
  setup() {
    const route: any = useRoute();
    const proxyData = reactive({
      route: route
    });
    onMounted(() => {
     
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
